import Component from './kebab-menu';

export * from './kebab-menu';
export default Component;
